import { useState, useRef, useEffect } from "react";
import AtkLoader from "../../../AtlaskitControls/AtkLoader";
import { InputTextarea } from "primereact/inputtextarea";
import { InputText } from "primereact/inputtext";
import Base64Image from "../Template-1/Base64Image";
export default function ContactUs(props: any) {
  const [isPreparedByEditing, setIsPreparedByEditing] = useState(false);
  const [isWebsiteEditing, setIsWebsiteEditing] = useState(false);

  return (
    <div className="container p-0  border">
      <section className="section-contact ">
        <div className="row d-flex align-items-center  px-3">
          <div className="d-flex align-items-center justify-content-center my-3 ">
            <img className="display-for-desktop-flex" src="https://app.strongproposals.com/assets/img/default-avatar.jpg" height={150} alt="" />
            <span className="ms-2 flex-grow-1 ">
              {/* <img className="w-auto mx-auto" height={30} src={props.logoURL} alt="" /> */}
              <Base64Image imageUrl={props.logoURL} className="w-auto mx-auto" height="30" alt="Insurance Image" />
              {props.isEditable && !props.isGeneratingPdf ? (
                <>
                  {!isPreparedByEditing ? (
                    <i
                      className="fa fa-pencil text-12 ms-2 show-cursor d-flex flex-row justify-content-end mb-1"
                      title="Edit"
                      onClick={() => setIsPreparedByEditing(true)}
                    />
                  ) : (
                    <span className="text-12  d-flex flex-row justify-content-end mb-1 ">
                      {isPreparedByEditing && props.saveLoading ? (
                        <div className="d-inline-flex align-items-center">
                          <AtkLoader />
                        </div>
                      ) : (
                        <i
                          className="fa fa-check mx-2 show-cursor text-success"
                          onClick={() => {
                            setIsPreparedByEditing(false);
                            props.onTemplateDetailsSave();
                          }}
                          title="Save"
                        />
                      )}
                      <i
                        className="fa fa-times show-cursor text-danger"
                        title="Cancel"
                        onClick={() => {
                          setIsPreparedByEditing(false);
                          props.onCancelTemplateDetailsToSave();
                        }}
                      />
                    </span>
                  )}
                </>
              ) : null}
              {isPreparedByEditing ? (
                <span className="w-100">
                  <InputTextarea value={props.preparedBy} onChange={props.onPreparedByChange} autoResize className="text-12  mt-1 w-100" />
                </span>
              ) : (
                <span className="text-dark opacity-75 text-14">
                  <p className="mb-1 w-75 ">{props.preparedBy} </p>
                </span>
              )}
              {props.isEditable && !props.isGeneratingPdf ? (
                <>
                  {!isWebsiteEditing ? (
                    <i
                      className="fa fa-pencil text-12 ms-2 show-cursor d-flex flex-row justify-content-end mb-1"
                      title="Edit"
                      onClick={() => setIsWebsiteEditing(true)}
                    />
                  ) : (
                    <span className="text-12 d-flex flex-row justify-content-end mb-1">
                      {isWebsiteEditing && props.saveLoading ? (
                        <div className="d-inline-flex align-items-center">
                          <AtkLoader />
                        </div>
                      ) : (
                        <i
                          className="fa fa-check mx-2 show-cursor text-success"
                          title="Save"
                          onClick={() => {
                            setIsWebsiteEditing(false);
                            props.onTemplateDetailsSave();
                          }}
                        />
                      )}
                      <i
                        className="fa fa-times show-cursor text-danger"
                        title="Cancel"
                        onClick={() => {
                          setIsWebsiteEditing(false);
                          props.onCancelTemplateDetailsToSave();
                        }}
                      />
                    </span>
                  )}
                </>
              ) : null}
              {isWebsiteEditing ? (
                <div>
                  <InputText value={props.website} onChange={props.onWebsiteUrlChange} className="text-12 w-50 mt-1" />
                </div>
              ) : (
                <p className="small mb-0">Website: {props.website}</p>
              )}{" "}
            </span>
          </div>
        </div>
      </section>
    </div>
  );
}
